<!-- rakumart QA -->
<template>
  <div>
    <ohead />
    <div class="pageBody">
      <searchModel />
      <div class="don">
        <template v-if="showpage.menuLevel == 1">
          <div v-html="showpage.content" :key="contentKey"></div>
        </template>
        <template v-if="showpage.menuLevel == 2">
          <div class="secconBox">
            <div class="titleBox">
              <span class="pageNameSpan" @click="$fun.routerToPage('/FAQ')">{{
                helpCenterLabel
              }}</span>
              <i class="el-icon-arrow-right"></i>
              <span class="blurFont">{{ showpage.menu }}</span>
            </div>
            <div class="BodyBox">
              <leftMenu :actMenuKey="showpage.menuKey" />
              <div class="rightBox">
                <div class="showBodyBoxTitle">
                  {{ showpage.title }}
                </div>
                <div v-if="showpage.answer" class="showBodyBoxAnswer">
                  {{ showpage.answer }}
                </div>
                <div v-html="showpage.content" :key="contentKey"></div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="showpage.menuLevel == 3">
          <div class="secconBox">
            <div class="titleBox">
              <span class="pageNameSpan" @click="$fun.routerToPage('/FAQ')">{{
                helpCenterLabel
              }}</span>
              <i class="el-icon-arrow-right"></i>
              <span class="blurFont blurLink" @click="goParentMenu">{{
                showpage.menu
              }}</span>
              <i class="el-icon-arrow-right"></i>
              <span class="blurFont">{{ showpage.pageName }}</span>
            </div>
            <div class="BodyBox">
              <leftMenu :actMenuKey="showpage.menuKey" />
              <div class="rightBox thred">
                <div v-html="showpage.title"></div>
                <!-- titleFontThree：有需要时再放出 answer 摘要区
                <div v-html="showpage.answer" class="titleFontThree"></div>
                -->
                <div class="dianzi"></div>
                <div v-html="showpage.content" :key="contentKey"></div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <contactUs />
    <ofooter />
  </div>
</template>
<script>
import ohead from "@/components/head/HomePageTop.vue";
import searchModel from "./components/searchModel.vue";
import ofooter from "@/components/foot/Foot.vue";
import pageData, { faqCategories } from "./unitl/pageData";
import leftMenu from "./components/leftMenu.vue";
import contactUs from "./components/contactUs.vue";
import { resolveFaqPage, getFaqLabel } from "./unitl/faqLocale";

export default {
  data() {
    return {
      pageData,
      contentKey: 0,
    };
  },
  components: {
    ohead,
    searchModel,
    contactUs,
    ofooter,
    leftMenu,
  },
  computed: {
    rawPage() {
      return (
        pageData.find((item) => item.router == this.$route.name) || {
          menuLevel: 1,
        }
      );
    },
    showpage() {
      return resolveFaqPage(this.rawPage, this.$store.state.fanyi);
    },
    homePage() {
      return pageData.find((item) => item.router === "centro-de-ayuda") || {};
    },
    helpCenterLabel() {
      return getFaqLabel(
        this.homePage.uiLabels,
        "helpCenter",
        this.$store.state.fanyi,
      );
    },
  },
  watch: {
    "$store.state.fanyi"() {
      this.contentKey += 1;
      this.$nextTick(() => {
        this.bindClickHandlers();
      });
    },
    "showpage.content"() {
      this.$nextTick(() => {
        this.bindClickHandlers();
      });
    },
  },
  mounted() {
    this.bindClickHandlers();
  },
  updated() {
    this.bindClickHandlers();
  },
  methods: {
    // 三级页面包屑：点击二级分类名返回对应二级目录
    goParentMenu() {
      const menuKey = this.rawPage.menuKey;
      if (!menuKey) return;
      const cat = faqCategories.find((item) => item.menuKey === menuKey);
      if (cat && cat.router) {
        this.$fun.routerToPage("/" + cat.router);
      }
    },
    bindClickHandlers() {
      const divArr = document.getElementsByName("myClick");
      divArr.forEach((divItem) => {
        if (divItem.__faqClickBound) return;
        divItem.__faqClickBound = true;
        divItem.addEventListener("click", () => {
          const clickExpr = divItem.getAttribute("@click");
          if (clickExpr) {
            const _this = this;
            eval("_this." + clickExpr);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
@import "./css/pagecss.scss";
.blurFont {
  color: #009246;
}
.blurLink {
  cursor: pointer;
}
.pageBody {
  .don {
    background-color: white;
    padding-bottom: 1px;
    .secconBox {
      width: 1000px;
      margin: 0 auto;
      .titleBox {
        padding: 30px 10px 24px;
        font-size: 14px;
        .pageNameSpan {
          color: #7a7a7a;
          cursor: pointer;
        }
        .el-icon-arrow-right {
          margin: 0 10px;
          color: #009246;
        }
      }
      .BodyBox {
        margin: 20px 0 80px;
        display: flex;
        align-items: flex-start;
        hr {
          margin: 20px 0;
          background-color: #d5d5d5;
          width: 100%;
        }
        .dianzi {
          height: 14px;
        }
      }
      .rightBox {
        flex: 1;

        padding: 10px;
      }
      .rightBox.thred {
        max-width: 738px;
        color: #404040;
      }
      /deep/.showBodyBoxTitle {
        font-size: 26px;
        font-weight: 600;
        line-height: 1.35;
        color: #1a1a1a;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid #eaecf0;
      }
      /* titleFontThree：有需要时再放出
      /deep/.titleFontThree {
        .showBodyBoxAnswer {
          font-size: 15px;
          font-weight: 400;
          line-height: 2em;
        }
      }
      */
      /deep/.showBodyBoxAnswer {
        font-size: 14px;
        line-height: 1.5;
        color: #404040;
      }
    }
  }
}
</style>
